import produce from 'immer';

import type { IceResponse, TabbedIceData } from '../types';
import getPromotionTabForTaskState from '../utils/getPromotionTabForTaskState';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  crmPromotionsRequested: (state: State): State => ({
    ...state,
    isCrmLoading: true
  }),
  icePromotionsRequested: (state: State): State => ({
    ...state,
    isIceLoading: true
  }),

  crmPromotionsLoaded: (state: State, payload: string[] | undefined): State => ({
    ...state,
    crm: payload ?? [],
    hasCrmErrored: false,
    isCrmLoading: false
  }),
  crmPromotionsFailed: (state: State): State => ({
    ...state,
    hasCrmErrored: true,
    isCrmLoading: false
  }),
  icePromotionsLoaded: (state: State, payload: IceResponse): State => {
    const ice = payload.promotions.reduce<TabbedIceData>(
      (tabbedPromotions, promotion) => {
        const [{ taskId, taskState }] = promotion.tasks;
        const userTask = payload.userTaskBody.find(
          (userPromotion) => userPromotion.taskId === taskId
        );
        const tab = getPromotionTabForTaskState(userTask ? userTask.userTaskState : taskState);

        if (tab) {
          return {
            ...tabbedPromotions,
            [tab]: [
              ...tabbedPromotions[tab],
              {
                ...promotion,
                userTask,
                progressAvailable: promotion.promoType !== 1 && promotion.tasks.length === 1
              }
            ]
          };
        }

        return tabbedPromotions;
      },
      { LIVE: [], COMPLETED: [] }
    );
    return {
      ...state,
      ice,
      hasIceErrored: false,
      isIceLoading: false
    };
  },
  icePromotionsFailed: (state: State): State => ({
    ...state,
    hasIceErrored: true,
    isIceLoading: false
  }),
  icePromotionsCleared: (state: State): State => ({
    ...state,
    ice: { LIVE: [], COMPLETED: [] }
  }),
  preloaded: (state: State): State => ({
    ...state,
    hasPreloaded: true,
    isIceLoading: false,
    isCrmLoading: false
  }),
  clear: (): State => produce(defaultState, (draft) => draft)
};
